import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import UserAgent from './useragent';

import './menu.css';

const DATA_NAME = "data-menu-";
const MENU_OPEN = DATA_NAME+"open";
const MENU_NAME = DATA_NAME+"name";
const MENU_FUNC_DIRECTION = DATA_NAME+"direction";

class MenuTrigger {
  constructor($el,className) {
    let direction,background;
    this.$el = $el;
    this.className = className;
    this.controlName = this.$el.attr('aria-controls');
    this.$control = $('#' + this.controlName );
    this.$background = '';
    this.limited = this.$el.attr(DATA_NAME+'-trigger');
    this.expand = false;
    this.$el.attr('aria-expanded', false);
    this.$control.attr('aria-hidden', true);
    if(!this.$control.hasClass(this.className+'-body')){
      this.$control.addClass(this.className+'-body');
      /* this.$control.wrapInner($('<div>').addClass(this.className+'-content'));
      direction = this.$control.attr(MENU_FUNC_DIRECTION);
      */
      if(direction == 'left' || direction == 'right'){
        background = this.className+'-background';
        this.$control.prepend($('<div>').addClass(background));
        this.$background = this.$control.children('.'+background);
      }
    }
    /*this.$controlWrap = this.$control.children('.'+this.className+'-content');*/
    this.setEvent();
  }
  setEvent(){
    $(this.$el).click(event => {
      this.action();
    });
    if(this.$background){
      $(this.$background).click(event => {
        this.action();
      });
    }
  }
  action() {
    let hideFlag;
    hideFlag = this.$control.attr('aria-hidden');
    if(this.limited === 'open'){
      hideFlag = false;
    }else if(this.limited === 'close'){
      hideFlag = true;
    }
    if (hideFlag == 'true') {
      this.show();
    } else {
      this.hide();
    }
  }
  show() {
    let expand = true;
    $('.'+this.className+'-trigger[aria-controls='+this.$el.attr('aria-controls')+']').attr('aria-expanded', expand);
    this.$control.attr('aria-hidden', !expand);
    this.$control.find('a').on('click.menu', event => {
      let targetUrl, hash,currentUrl;
      targetUrl = $(event.currentTarget).attr('href');
      if(targetUrl.match(/#(.*)+/g)){
        hash = targetUrl.match(/#(.*)+/g)[0];
        currentUrl = $(event.currentTarget)[0].pathname;
        if (hash && currentUrl === location.pathname) {
          this.hide();
        }
      }
    });

    if(UserAgent.isMobile()){
      disableBodyScroll(document.querySelector('#' + this.controlName));
    }
    $('body').attr({[MENU_NAME]:this.controlName,[MENU_OPEN]:true});
  }
  hide() {
    let expand = false;
    $('.'+this.className+'-trigger[aria-controls='+this.$el.attr('aria-controls')+']').attr('aria-expanded', expand);
    this.$control.attr('aria-hidden', !expand);
    this.$control.find('a').off('click.menu');
    enableBodyScroll(document.querySelector('#' + this.controlName ));
    $('body').attr({[MENU_NAME]:null,[MENU_OPEN]:false});
  }
}

class Menu {
  constructor(className) {
    this.className = className;
    this.trigger = $('.'+this.className+'-trigger');
    this.menuArr = [];
    this.initTrigger();
  }
  initTrigger(){
    this.trigger.each((index, element) => {
      let drawmenu;
      drawmenu = new MenuTrigger($(element),this.className);
      this.menuArr.push(drawmenu);
    });
  }
}

new Menu('js-menu');
